/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Cc_CreatorInputs */

const en_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About CC Creator`)
};

const fr_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de CC Creator`)
};

const de_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über CC Creator`)
};

const it_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni su CC Creator`)
};

const ru_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О CC Creator`)
};

const es_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de CC Creator`)
};

const zh_cn2_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 CC Creator`)
};

const ja_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCクリエイターについて`)
};

const hi_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीसी क्रिएटर के बारे में`)
};

const pt_pt2_about_cc_creator = /** @type {(inputs: About_Cc_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o CC Creator`)
};

/**
* | output |
* | --- |
* | "About CC Creator" |
*
* @param {About_Cc_CreatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const about_cc_creator = /** @type {((inputs?: About_Cc_CreatorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Cc_CreatorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about_cc_creator(inputs)
	if (locale === "de") return de_about_cc_creator(inputs)
	if (locale === "it") return it_about_cc_creator(inputs)
	if (locale === "ru") return ru_about_cc_creator(inputs)
	if (locale === "es") return es_about_cc_creator(inputs)
	if (locale === "zh-CN") return zh_cn2_about_cc_creator(inputs)
	if (locale === "ja") return ja_about_cc_creator(inputs)
	if (locale === "hi") return hi_about_cc_creator(inputs)
	if (locale === "pt-PT") return pt_pt2_about_cc_creator(inputs)
	return en_about_cc_creator(inputs)
});